/*
==========================================
Custom CSS for Subscription list/detail Page
==========================================
*/

// 定期便/定期購入 → 頒布会へのテキスト変更
window.addEventListener('load',() =>{
  // テキスト変換メソッド
  const replaceText = (_elem) => {
        if (_elem.innerHTML.includes("直送定期便")) {
        return;  // すでに置換されている場合は何もしない
    }
    let HTMLContent = _elem.innerHTML;
    HTMLContent = HTMLContent.replace('定期便', '直送定期便');
    _elem.innerHTML = HTMLContent;
  }
  // -- 一覧ページ --
  const topIntervalId = setInterval(()=>{
    const appTitleContent = document.getElementById('mikawaya-subscription-list-title');
    if(appTitleContent){
      // ヘッダーテキスト
      const pageHeader = document.querySelector('#mikawaya-subscription-list-title .chakra-text');
      if(pageHeader) replaceText(pageHeader);
           if(pageHeader) clearInterval(pageHeader);
      // アイテム一覧
      const pageListHeader = document.querySelector('#mikawaya-subscription-list-special-offer-text + .chakra-text');
      if(pageListHeader) replaceText(pageListHeader);
            if(pageListHeader) clearInterval(pageListHeader);
    }
  },300);

  // -- 詳細ページ --
  const detailIntervalId = setInterval(()=>{
    const appBackBtnContent = document.getElementById('mikawaya-subscription-lines-back-button');
    if(appBackBtnContent){
      // 戻るボタン
      const pageBackBtn = document.querySelector('#mikawaya-subscription-lines-back-button');
      if(pageBackBtn) replaceText(pageBackBtn);
            if(pageBackBtn) clearInterval(pageBackBtn);
    }
  },300);

  
});